import script from "./qrcode.vue?vue&type=script&lang=tsx&setup=true"
export * from "./qrcode.vue?vue&type=script&lang=tsx&setup=true"

import "./qrcode.vue?vue&type=style&index=0&id=b345dbac&lang=scss"

const __exports__ = script;

export default __exports__